import { AxiosError, isAxiosError } from 'axios';

interface ISignUpApiResponseData {
  message?: string;
  error?: string;
  data?: { message?: string; error?: string };
}

const firstString = (...values: Array<string | undefined>): string | undefined =>
  values.find((v): v is string => typeof v === 'string' && v.trim().length > 0);

/**
 * Catch-all for axios errors that carry a BE-supplied message but don't match
 * any of the specific typed errors above. Placed last in the service chain so
 * the user sees whatever copy auth-service wrote instead of the generic axios
 * "Request failed with status code …" string.
 */
export class SignUpApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SignUpApiError';
  }

  static fromAxiosError(error: unknown): SignUpApiError | null {
    if (!isAxiosError(error)) {
      return null;
    }

    const axiosError = error as AxiosError<ISignUpApiResponseData>;
    const data = axiosError.response?.data;
    const message = firstString(
      data?.message,
      data?.error,
      data?.data?.message,
      data?.data?.error,
    );

    return message ? new SignUpApiError(message) : null;
  }
}
